import React from 'react';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import allReducers from './module';
const composeEnhancer = composeWithDevTools(applyMiddleware(thunk));
const store = createStore(allReducers, composeEnhancer);
export function StoreProvider({ children }) {
    return <Provider store={store}>{children}</Provider>;
}
